import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AdminAttributionDisputesPage } from '@/features/attribution-disputes/pages/admin-attribution-disputes-page'

export const Route = createFileRoute('/attribution-disputes')({
  staticData: { title: 'Attribution' },
  validateSearch: z.object({
    status: z.enum(['open', 'upheld', 'rejected', 'withdrawn']).optional(),
    page: z.coerce.number().int().min(1).optional(),
    selected: z.string().min(1).optional(),
  }),
  component: AdminAttributionDisputesPage,
})
